module.exports = __webpack_public_path__ + "img/customize.73f8b42a.svg";